export default [
  {id: 1, nome: 'Ensino fundamental'},
  {id: 2, nome: 'Ensino Médio'},
  {id: 3, nome: 'Ensino Superior'}
]



// WEBPACK FOOTER //
// ./src/app/website/trabalhe-conosco/escolaridade.js